import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingService } from '../../../../core/services/setting.service';
import { ExecutionPurchaseService } from '../../../../core/services/execution-purchase.service';
import { forkJoin } from 'rxjs';
import { LoadingState } from '../../loading/loading.component';
import { AddMaterialModalComponent } from '../add-material-modal/add-material-modal.component';

@Component({
  selector: 'app-crusher-tab',
  templateUrl: './crusher-tab.component.html',
  styleUrls: ['./crusher-tab.component.scss']
})
export class CrusherTabComponent implements OnInit {

  @Input() tenderId: number;
  // @Input() tenderMaterialList: any = [];
  type: string;
  tenderMaterialList: any = [];
  loading: LoadingState = LoadingState.NotReady;
  typeId:number;
  constructor(
    public dialog: MatDialog,
    private settingService: SettingService,
    private executionPurchaseService: ExecutionPurchaseService
  ) { }

  ngOnInit() {
    this.type = "crusher"
    this.getMaterialType();
  }

  openMaterialModal() {
    let dialogRef = this.dialog.open(AddMaterialModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId,type: 'crusher' }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result['data'] != undefined) {
        this.tenderMaterialList.push(result['data'])
      }
    })
  }

  getMaterialType() {
    this.settingService.getMaterialType().subscribe(
      res => {
        var masterData = res['result'];
        this.typeId = masterData.filter(x => x.type_name == "Materials")[0].code;
        if (this.typeId) {
          this.loadData()
        }
      }
    )
  }

  loadData() {
    var forkArray = [];
    let params: URLSearchParams = new URLSearchParams();
    var is_crusher = 1
    var itemPerPage = 0;
    params.set('page_size', itemPerPage.toString());
    params.set('type_code', this.typeId.toString());
    params.set('is_crusher', is_crusher.toString());
    forkArray.push(this.executionPurchaseService.getMaterialList(params))
    forkJoin(forkArray).subscribe(
      ([materialData]) => {
        // console.log(result)
        this.tenderMaterialList = materialData['results'];
      //  console.log(this.tenderMaterialList)
        this.loading = LoadingState.Ready;
      },
      err => {
        this.loading = LoadingState.Ready;
        // console.log(err)
      }
    )
  }

}
